
import mapboxgl from 'mapbox-gl';
import { FeatureCollection } from 'geojson';

export const initializeSource = (
  map: mapboxgl.Map, 
  geoJsonData: FeatureCollection
): void => {
  if (!map.getSource('regions')) {
    map.addSource('regions', {
      type: 'geojson',
      data: geoJsonData,
      tolerance: 0.01,
      buffer: 128,
    });
  } else {
    const source = map.getSource('regions') as mapboxgl.GeoJSONSource;
    source.setData(geoJsonData);
  }
};
